import { useState, useEffect } from "react";
import { apiGet } from "@/config";
import ArticleCard from "@/components/ArticleCard";

const ArticlePage = ({ articleId, onBack }) => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      setLoading(true);
      try {
        const { data } = await apiGet(`/articles/${articleId}`);
        setArticle(data);
      } catch {
        setError("Article not found");
      } finally {
        setLoading(false);
      }
    };
    fetchArticle();
  }, [articleId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-white text-xl">Loading article...</div>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center gap-4">
        <p className="text-slate-400 text-lg">{error || "Article not found"}</p>
        <button onClick={onBack} className="text-blue-400 hover:text-blue-300 font-medium">
          Back to homepage
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-950">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <button
          onClick={onBack}
          data-testid="back-to-home"
          className="text-blue-400 hover:text-blue-300 font-medium mb-6 flex items-center gap-1"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to homepage
        </button>
        <ArticleCard article={article} onEdit={() => {}} onDelete={() => {}} isAdmin={false} defaultExpanded />
      </div>
    </div>
  );
};

export default ArticlePage;
